import {Dispatch, ReactNode, SetStateAction} from 'react';
import {BaseUser, BodySite, Condition, ScoringSystemItem, ScoringSystem} from '@legit.health/ui';
import {TFunction} from 'i18next';
import {AnamnesisQuestion} from '@/shared/interfaces/AnamnesisQuestion';
import isAlopeciaFn from '@/shared/utils/isAlopecia';
import {ConditionInfo, CreateDiagnosticReportResponse} from '../../types';
import FollowUpForm from './FollowUpForm';
import Alopecia from './components/Alopecia';

export default function FollowUpFormContainer(props: {
  anamnesisQuestions: AnamnesisQuestion[];
  conditionId: string;
  conditions: Condition[];
  conditionInfo: ConditionInfo | null;
  currentStep: number;
  extraPostData?: (conditionId: string | null) => Record<string, any>;
  isForClinicalTrials: boolean;
  onSuccess: (values: CreateDiagnosticReportResponse) => void;
  patient: BaseUser;
  renderItemLabel?: (options: {
    item: ScoringSystemItem;
    scoringSystem: ScoringSystem;
    bodySite: BodySite;
  }) => string;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  steps: {label: string; icon: ReactNode}[];
  t: TFunction;
  visitIdentifier: string;
  withTemporaryImages: boolean;
}) {
  const condition = props.conditions.find((c) => c.id === parseInt(props.conditionId));
  if (!condition) {
    throw new Error(`Invalid condition id: ${props.conditionId}`);
  }
  const isAlopecia = isAlopeciaFn(condition.pathology);
  if (isAlopecia) {
    return <Alopecia {...props} condition={condition} />;
  }
  return <FollowUpForm {...props} condition={condition} />;
}
